import { render, staticRenderFns } from "./pkg.vue?vue&type=template&id=8411dc3e&scoped=true&"
import script from "./pkg.vue?vue&type=script&lang=js&"
export * from "./pkg.vue?vue&type=script&lang=js&"
import style0 from "./pkg.vue?vue&type=style&index=0&id=8411dc3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8411dc3e",
  null
  
)

export default component.exports